'use strict'

import Vue from 'vue'

export const shared = new Vue({
  data: {
    root: 'https://chocomint.dulcetsehr.net/',
    apiroot: 'https://chocomintapi.dulcetsehr.net/',
    user: null,
    lang: 'ko',
  },
  methods: {
    initLanguage() {
      let lang = window.getCookie('xV7jcegkgd') || navigator.language || navigator.userLanguage
      if(lang == 'ja-JP' || lang == 'ja') lang = 'ja'
      else lang = 'ko'
      this.changeLanguage(lang)
    },
    changeLanguage(lang) {
      this.lang = lang
      window.setCookie('xV7jcegkgd', this.lang, 365)
    },
  },
})